import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ConfusedStan } from "../../constants/stan";
import classes from "./index.module.css";
import { YellowButton } from "../../components/UI/Button/button";
import femaleSupport from "../../assets/illustrations/female-support.png";
import maleSupport from "../../assets/illustrations/male-support.png";

const Report = ({ type }) => {
  const navigate = useNavigate();
  const array = [
    {
      to: type === "client" ? "/client-report-behaviour" : "/talent-report-behaviour",
      text: "Report Behaviour",
      subtitle: "Is there some concern you have towards anyone on the platform?",
      shirtColor: "#F9A910",
      btnTxt: "Report behaviour"
    },
    {
      to: type === "client" ? "/client-contact-us" : "/talent-contact-us",
      text: "Contact Us",
      subtitle: "Got something else on your mind? Share with us",
      shirtColor: "#030659",
      btnTxt: "Contact Us"
    },
    {
      to: type === "client" ? "/client-report-a-bug" : "/talent-report-a-bug",
      text: "Log a Bug",
      subtitle: "Any issue or experience on the platform you encountered",
      shirtColor: "#009A49",
      btnTxt: "Log a Bug"
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={`${classes.supportMain}`}>
      <h2>Need Support?</h2>
      <div className={`flex center ${classes.supportContainer}`}>
        {array.map((links, i) => (
          <Link to={links.to} key={`reports-${i}`} className={classes.supportCard}>
            {links.text === "Report Behaviour" && <ConfusedStan shirtColor={links.shirtColor} />}
            {links.text === "Contact Us" && <div className={classes.imgCard}> <img src={femaleSupport} alt="Support" /> </div>}
            {links.text === "Log a Bug" &&  <div className={classes.imgCard}> <img src={maleSupport} alt="Support" /></div> }

            <hr />
            <h6>{links.text}</h6>
            <p>{links.subtitle}</p>
            <YellowButton onClick={() => navigate(links.to)}>{links.btnTxt}</YellowButton>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Report;
